/**
 * @module ol/control/Refresh
 */

import Control from "ol/control/Control";
import { CLASS_CONTROL, CLASS_UNSELECTABLE } from "ol/css";

class Refresh extends Control{
   /**
   * @param {Options} [options] Options.
   */

   constructor(options){
    options = options ? options : {};
    
    super({
        element: document.createElement('div'),
        target: options.target,
    });

    const className = options.className !== undefined ? options.className : 'ol-refresh';

    const label = options.label !== undefined ? options.label : '';
    const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Recargar mapa';
    const button = document.createElement('button');
    button.setAttribute('type', 'button');
    button.title = tipLabel;
    button.appendChild(
      typeof label === 'string' ? document.createTextNode(label) : label,
    )

    button.addEventListener('click',(e) => {
        e.preventDefault()
        //url a la que lleva el refresh
        location.href = 'https://estadistica.tucuman.gob.ar/visor';
    })


    const cssClasses = className + ' ' + CLASS_UNSELECTABLE + ' ' + CLASS_CONTROL;
    const element = this.element;
    element.className = cssClasses;
    element.appendChild(button);

   }

}



export default Refresh